$shm_hitalama_speech_picker $mol_pick
	trigger_content /
		<= Trigger_icon $mol_icon_dots_vertical
	bubble_content /
		<= Speaker_label $mol_labeler
			title \Вывод звука
			Content <= Speaker $mol_switch
				options <= speakers *
				value? <=> speaker? \
		<= Mic_label $mol_labeler
			title \Микрофон
			Content <= Mic $mol_switch
				options <= microphones *
				value? <=> mic? \
